import { __decorate, __metadata, __param } from 'tslib';
import { CommonModule } from '@angular/common';
import { ɵɵdefineInjectable, ɵɵinject, Injectable, Inject, NgModule, Optional, SkipSelf } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { Storage, IonicStorageModule } from '@ionic/storage';
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';
import { APP_PARAMETER } from '@wlp/ui-bs-parameter';
import { BaseService, ErrorMessageService, MaskService, UiBsUtilModule } from '@wlp/ui-bs-util';
import { ConfigService, SpeViewNMenuProxy, SpeNAccountProxy, SpeViewNAccountProxy, SpeNAccountsProxy, UiPxDashboardModule } from '@wlp/ui-px-dashboard';
export { CheckMigrationResponseDto, ContractMigrationDto, MigrationResponse, StatusStepMigrationEnum } from '@wlp/ui-px-dashboard';

let ShortcutsService = class ShortcutsService extends BaseService {
    constructor(storage, configService, speViewNMenuProxy) {
        super(storage, configService);
        this.storage = storage;
        this.configService = configService;
        this.speViewNMenuProxy = speViewNMenuProxy;
    }
    getAllShortcuts(uuidWhiteLabel, uuidAccountPayment, platform) {
        return this.speViewNMenuProxy.getAllShortcuts(uuidWhiteLabel, uuidAccountPayment, platform);
    }
};
ShortcutsService.ngInjectableDef = ɵɵdefineInjectable({ factory: function ShortcutsService_Factory() { return new ShortcutsService(ɵɵinject(Storage), ɵɵinject(ConfigService), ɵɵinject(SpeViewNMenuProxy)); }, token: ShortcutsService, providedIn: "root" });
ShortcutsService = __decorate([
    Injectable({
        providedIn: 'root',
    }),
    __metadata("design:paramtypes", [Storage,
        ConfigService,
        SpeViewNMenuProxy])
], ShortcutsService);

let UserBankInfoService = class UserBankInfoService extends BaseService {
    constructor(speNAccountProxy, storage, configService, errorMessageService, maskService, param) {
        super(storage, configService);
        this.speNAccountProxy = speNAccountProxy;
        this.storage = storage;
        this.configService = configService;
        this.errorMessageService = errorMessageService;
        this.maskService = maskService;
    }
    getUserBank() {
        this.speNAccountProxy
            .getUserBankInfo(this.keyPreAccount)
            .subscribe(data => {
            // balance = data;
        }, err => this.errorMessageService.getError(err));
        this.userBank = {
            accountNumber: '123456-7',
            agency: '0001',
            bank: 'PSXBank',
            digit: '093',
            userEmail: 'rafaela.rago@payshopx.com.br',
            userName: 'Rafaela',
            userCompleteName: 'Rafaela Targino Rago',
        };
        return this.userBank;
    }
};
UserBankInfoService = __decorate([
    Injectable(),
    __param(5, Inject(APP_PARAMETER)),
    __metadata("design:paramtypes", [SpeNAccountProxy,
        Storage,
        ConfigService,
        ErrorMessageService,
        MaskService, Object])
], UserBankInfoService);

let MigrationService = class MigrationService extends BaseService {
    constructor(storage, configService, speViewNAccountProxy, speNAccountProxy) {
        super(storage, configService);
        this.storage = storage;
        this.configService = configService;
        this.speViewNAccountProxy = speViewNAccountProxy;
        this.speNAccountProxy = speNAccountProxy;
    }
    getCheckMigration() {
        return this.speViewNAccountProxy.getCheckMigration();
    }
    acceptMigration() {
        return this.speNAccountProxy.acceptMigration();
    }
};
MigrationService.ngInjectableDef = ɵɵdefineInjectable({ factory: function MigrationService_Factory() { return new MigrationService(ɵɵinject(Storage), ɵɵinject(ConfigService), ɵɵinject(SpeViewNAccountProxy), ɵɵinject(SpeNAccountProxy)); }, token: MigrationService, providedIn: "root" });
MigrationService = __decorate([
    Injectable({
        providedIn: 'root',
    }),
    __metadata("design:paramtypes", [Storage,
        ConfigService,
        SpeViewNAccountProxy,
        SpeNAccountProxy])
], MigrationService);

let AccountsBenefitsService = class AccountsBenefitsService extends BaseService {
    constructor(storage, configService, speNAccountsProxy) {
        super(storage, configService);
        this.storage = storage;
        this.configService = configService;
        this.speNAccountsProxy = speNAccountsProxy;
    }
    newValue(uuidAccountPayment) {
        return this.speNAccountsProxy.newValueUrl(uuidAccountPayment);
    }
};
AccountsBenefitsService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [Storage,
        ConfigService,
        SpeNAccountsProxy])
], AccountsBenefitsService);

var UiBsDashboardModule_1;
let UiBsDashboardModule = UiBsDashboardModule_1 = class UiBsDashboardModule {
    constructor(parentModule) {
        //...
    }
    static forRoot(config) {
        return {
            ngModule: UiBsDashboardModule_1,
            providers: [
                { provide: APP_PARAMETER, useValue: config }
            ]
        };
    }
};
UiBsDashboardModule = UiBsDashboardModule_1 = __decorate([
    NgModule({
        imports: [
            CommonModule,
            FormsModule,
            IonicModule,
            IonicStorageModule.forRoot({
                driverOrder: ['indexeddb', 'sqlite', 'websql']
            }),
            UiPxDashboardModule,
            UiBsUtilModule,
            RxReactiveFormsModule
        ],
        providers: [
            AccountsBenefitsService,
            UserBankInfoService,
            ShortcutsService,
            MigrationService,
        ],
        exports: [RxReactiveFormsModule]
    }),
    __param(0, Optional()), __param(0, SkipSelf()),
    __metadata("design:paramtypes", [UiBsDashboardModule])
], UiBsDashboardModule);

class UserBankInfoResponse {
}

class NewValueDTO {
}

export { AccountsBenefitsService, MigrationService, NewValueDTO, ShortcutsService, UiBsDashboardModule, UserBankInfoResponse, UserBankInfoService };
//# sourceMappingURL=wlp-ui-bs-dashboard.js.map
